import { useState, useEffect } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Typography, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import PageService from '../../services/PageService'

const EditVersionModal = ({
  dropdownElInfo,
  editVersionOpen,
  setEditVersionOpen,
  setTestCasesToggler
}) => {
  const [newName, setNewName] = useState('')
  const [newNameError, setNewNameError] = useState('')
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setNewName(dropdownElInfo.name)
  }, [dropdownElInfo.name])

  const handleCloseDeleteDialog = () => {
    setEditVersionOpen(false)
    setNewName(dropdownElInfo.name)
    setNewNameError('')
  }

  const handleNameChange = (e) => {
    setNewName(e.target.value)

    if (newNameError) {
      setNewNameError('')
    }
  }

  const handleDeleteVersion = async () => {
    try {
      setDeleteLoading(true)
      await PageService.deleteProjectVersion(dropdownElInfo.id)
      setTestCasesToggler(prev => !prev)
      setEditVersionOpen(false)
      setNewName('')
    } catch (error) {
      console.log(error)
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleUpdateVersion = async () => {
    if (!newName.trim()) {
      setNewNameError('Name is required.')
      return
    } else {
      setNewNameError('')
    }

    try {
      setLoading(true)
      await PageService.updateProjectVersion(dropdownElInfo.id, newName)
      setTestCasesToggler(prev => !prev)
      setEditVersionOpen(false)
      setLoading(false)
    } catch (error) {
      if (error?.response?.status === 409) {
        setNewNameError(error.response.data?.error || 'A version with this name already exists. Please choose a different name.')
      } else {
        console.log(error)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={editVersionOpen} onClose={handleCloseDeleteDialog}>
      <Box className="editTestCaseVersionModal">
        <DialogTitle className="editTestCaseVersionModalTitle">
          Edit Version
        </DialogTitle>
        <DialogContent className="editTestCaseVersionModalContent">
          <Typography variant='body1' mb={2}>
            Please edit the name of version
          </Typography>
          <TextField
            label="Version Name*"
            type="text"
            fullWidth
            variant="outlined"
            value={newName}
            onChange={handleNameChange}
            error={!!newNameError}
            helperText={newNameError + ' '}
            inputProps={{ maxLength: 50 }}
          />
        </DialogContent>
        <DialogActions className="editTestCaseVersionModalActions">
          {deleteLoading ? (
            <LoadingButton
              loading
              className="deleteTestCaseVersionModalButton loadingButton"
              loadingIndicator={<CircularProgress color="error" size={16} />}
            />
          ) : (
            <Button className='deleteTestCaseVersionModalButton' onClick={handleDeleteVersion} color="error" variant="outlined">
              <DeleteOutlineOutlinedIcon color='error' />
            </Button>
          )}
          <Button className="editTestCaseVersionModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="editTestCaseVersionModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="editTestCaseVersionModalButton" onClick={handleUpdateVersion} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default EditVersionModal
